import { type FC } from 'react';

import { _notNil } from '@/littledash';
import type { Study } from '@/model/Study.model';

import type { SuccessfulOverviewSection } from '../../OverviewAccordion.model';
import OverviewTreatmentsTable from '../OverviewTreatmentsTable/OverviewTreatmentsTable';

interface TreatmentsSectionContentProps {
  section: SuccessfulOverviewSection<'treatments' | 'diseases'>;
  study?: Study;
  studyId?: string;
}

const SECTION_CLASSIFICATIONS = {
  treatments: 'treatment',
  diseases: 'disease_induction',
} as const;

/**
 * Renders Overview treatments or diseases with the same read columns as the matching
 * study-groups tab. Labels open the groups-table treatment info modal.
 */
const TreatmentsSectionContent: FC<TreatmentsSectionContentProps> = ({ section, study, studyId }) => {
  const classification = SECTION_CLASSIFICATIONS[section.type];

  return (
    <div data-test-component="TreatmentsSectionContent" data-test-element="container">
      <OverviewTreatmentsTable
        rows={section.rows}
        type={classification}
        studyApiId={study?.api_id}
        studyId={studyId ?? (_notNil(study) ? String(study.id) : undefined)}
      />
    </div>
  );
};

export default TreatmentsSectionContent;
